import { Injectable, Input, OnInit } from '@angular/core';
import { BaseDimensionComponent } from 'src/app/models/components/commonComponents/BaseDimensionComponent';
import { BaseComponent } from 'src/app/models/components/BaseComponent';
import { AdvancedPropertyComponent } from './advanced-property-component.interface';
import { getComponentFromSource } from '../generics-helper/getComponentFromSource.generic';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export abstract class BaseAdvancedPropertyViewComponent implements AdvancedPropertyComponent, OnInit {
  @Input('item') items: Array<BaseComponent>;
  baseDimension: BaseDimensionComponent = new BaseDimensionComponent();
  additionalData: any;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
  }

  ngOnInit(): void {

  }

  setBaseDimensions() {
    this.baseDimension = getComponentFromSource<BaseDimensionComponent>("BaseDimensionComponent", this.items);
  }

  // Every view component extending this class should override this method !
  saveButtonDisabledState(): boolean {
    return false;
  }
}
